import { render, staticRenderFns } from "./DoneAddModal.vue?vue&type=template&id=763b36d7"
import script from "./DoneAddModal.vue?vue&type=script&lang=js"
export * from "./DoneAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports